module.exports = __webpack_public_path__ + "img/idCard2.4503d633.png";